const camelize = require('camelize');

export function camelizeRecursive(object) {
  return camelize(object);
}



// WEBPACK FOOTER //
// ./header/scripts/utils/inflect.js